$(function() {

    $(document).on('click','.vendor',function() {
        var subvendor = $(this).data('subvendor');
        $(this).toggleClass('fa-arrow-down fa-arrow-up');
        $('[data-target-subvendor="'+subvendor+'"]').toggle();

    });

    $(document).on('click','.toggle-stats',function() {
        $(this).toggleClass('fa-eye fa-eye-slash');
        $('.hidden-stats').toggle();

    });

    $(document).on('click','.toggle-marchio',function() {
      var marchio = $(this).data("marchio");
      $(this).toggleClass('fa-chevron-circle-right fa-chevron-circle-down')
      $('tr[data-marchio="'+marchio+'"]').toggleClass('d-none');
    });

    $(document).on("click",".save_import_associates_data",function(e){

      console.log($(this).data('id'), $(this).parent('div').parent('div').find('div select[name="field"]').val(), $(this).parent('div').parent('div').find('div input[name="value"]').val());

      var self = $(this);

      $.ajax({
          url: '/ajax/import_associates_data',
          type: 'post',
          data: {
              id: $(this).data('id'),
              field : $(this).parent('div').parent('div').find('div select[name="field"]').val(),
              value: $(this).parent('div').parent('div').find('div input[name="value"]').val(),
          },
          success: function(response){
              console.log(response.html);
              self.siblings('.response').html(response.html);
          }
      });


  });

  $(document).on('click', '.editable', function() {
    //var element = "<input style='width:"+$(this).data('width')+"px' type='text' class='form-control form-control-sm text-center' name='element' value='"+$(this).data('value')+"' />";
    $(this).prop('readonly', false);
    $(this).toggleClass('editable editing').focus();
  });

  $(document).on('click', '[data-toggle="copy"]', function() {

    var $temp = $("<input>");
    $("body").append($temp);
    $temp.val($(this).data('text')).select();
    document.execCommand("copy");
    $temp.remove();
    alert($(this).data('text') + " copyed to clipboard");

  });

  function copyToClipboard(field) {
    /* Get the text field */




    /* Select the text field */
     /* For mobile devices */

     /* Copy the text inside the text field */


    /* Alert the copied text */
    alert("Copied the text: " + copyText.value);
  }

  /*  $(document).on("","",function(){

    }); */

  $(document).on('click', 'button[data-action="qr-notify"]', function() {

    var cid = $('input[name^="cid"]').serialize();
    if(!cid) {
        alert("Seleziona un ordine");
        return false;
    }

    if(!confirm('Sei sicuro di voler inviare il Qr Code agli iscritti selezionati?')) {
        return false;
    }

    window.location.href = "/administrator/events_users/qr-notify?" + cid;

  });

  $(document).on('click', 'button[data-action="warehouse"]', function() {

    var cid = $('input[name^="cid"]').serialize();
    if(!cid) {
        alert("Seleziona un ordine");
        return false;
    }
    window.location.href = "/administrator/orders/warehouse?" + cid;

  });

  $(document).on('click', 'button[data-action="labels"]', function() {

    var cid = $('input[name^="cid"]').serialize();
    if(!cid) {
        alert("Seleziona un ordine");
        return false;
    }
    window.location.href = "/administrator/orders/labels?" + cid;

  });

  $(document).on('click', 'button[data-action="orders"]', function() {

    var cid = $('input[name^="cid"]').serialize();
    if(!cid) {
        alert("Seleziona un ordine");
        return false;
    }
    window.location.href = "/administrator/orders/orders?" + cid;

  });

  $(document).on('click', 'button[data-action="invoices"]', function() {

    var cid = $('input[name^="cid"]').serialize();
    if(!cid) {
        alert("Seleziona un ordine");
        return false;
    }
    window.location.href = "/administrator/orders/invoices?" + cid;

  });

  $(document).on('click', 'button[data-action="mass_delete"]', function() {

    var cid = $('input[name^="cid"]').serialize();
    var model = $(this).data("model");
    if(!cid) {
        alert("Seleziona un ordine");
        return false;
    }

    console.log(model);

    window.location.href = "/administrator/"+model+"/mass_delete?" + cid;

  });

  $(document).on('click', 'button[data-action="export"]', function() {

    var start = $('input[name="start"]').val();
    if(!start) {
        alert("Seleziona un numero di partenza");
        return false;
    }
    window.location.href = "/administrator/products/export/" + start;

  });

  $(document).on('click', '.checkall', function() {
    $('.checkone').prop('checked', $(this).is(':checked'));
  });

  if (
    $('#transplant_plan_typology').val() == 'Congiunto (PTC)' ||
    $('#transplant_plan_typology').val() == 'Metropolitano (PTM)'
  ) {
    $('#transplant_plan_single_units_div').removeClass('d-none');
  } else {
    $('#transplant_plan_single_units_div').addClass('d-none');
  }

  $(document).on('change', '#transplant_plan_typology', function() {
    if (
      $(this).val() == 'Congiunto (PTC)' ||
      $(this).val() == 'Metropolitano (PTM)'
    ) {
      $('#transplant_plan_single_units_div').removeClass('d-none');
    } else {
      $('#transplant_plan_single_units_div').addClass('d-none');
    }
  });

  $(document).on('change', '#reference_type', function() {
    var reference_type = $(this).val();

    $.ajax({
      type: 'POST',
      url: '/ajax/reference_type',
      data: {
        reference_type: reference_type
      },
      success: function(data) {
        $('#xref_id').empty();
        $.each(data.options, function(key, value) {
          $('#xref_id').append(
            '<option value="' + key + '">' + value + '</option>'
          );
        });
        $('#xref_id').selectpicker('refresh');
      }
    });
  });

  $(document).on('focusout', '.editing', function() {
    var self = $(this);

    $.ajax({
      type: 'POST',
      url: '/ajax/setfield',
      data: {
        table: self.data('table'),
        field: self.data('field'),
        variant: self.data('variant'),
        operand: self.data('operand'),
        type: self.data('type'),
        id: self.data('id'),
        value: self.val()
      },
      success: function() {
        if (self.hasClass('bg')) {
          if (self.val() > 0) {
            self.removeClass('bg-danger').addClass('bg-success');
          } else {
            self.removeClass('bg-success').addClass('bg-danger');
          }
        }
        self.prop('readonly', true);
        self.toggleClass('editable editing');
      },
      error: function(xhr) {
        var message = (xhr.responseJSON && xhr.responseJSON.response && xhr.responseJSON.response.error)
          ? xhr.responseJSON.response.error
          : 'Errore durante l\'aggiornamento del campo';

        alert(message);

        if (self.data('original-value') !== undefined) {
          self.val(self.data('original-value'));
        }

        self.prop('readonly', true);
        self.toggleClass('editable editing');
      }
    });
  });

  $(document).on('focusin', '.editing', function() {
    var self = $(this);
    self.data('original-value', self.val());
  });

  $(document).on('changed.bs.select', '.order-payment-method', function() {
    var self = $(this);
    var previousValue = String(self.data('original-value'));

    if (String(self.val()) === previousValue) {
      return;
    }

    self.prop('disabled', true).selectpicker('refresh');

    $.ajax({
      type: 'POST',
      url: self.data('url'),
      data: { payment_id: self.val() },
      success: function() {
        window.location.reload();
      },
      error: function(xhr) {
        var message = xhr.responseJSON && xhr.responseJSON.message
          ? xhr.responseJSON.message
          : 'Errore durante l’aggiornamento del metodo di pagamento.';

        self.selectpicker('val', previousValue);
        self.prop('disabled', false).selectpicker('refresh');
        alert(message);
      }
    });
  });

  $(document).on('click', '.generate-order-payment-link', function() {
    var button = $(this);
    button.prop('disabled', true);

    $.ajax({
      type: 'POST',
      url: button.data('url'),
      success: function(data) {
        var result = button.siblings('.order-payment-link-result');
        result.find('.order-payment-link-open').attr('href', data.url);
        result.data('url', data.url).removeClass('d-none');
        button.addClass('d-none');
      },
      error: function(xhr) {
        var message = xhr.responseJSON && xhr.responseJSON.message
          ? xhr.responseJSON.message
          : 'Impossibile generare il link di pagamento.';
        alert(message);
        button.prop('disabled', false);
      }
    });
  });

  $(document).on('click', '.order-payment-link-copy', function() {
    var button = $(this);
    var url = button.closest('.order-payment-link-result').data('url');
    if (!url) return;

    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(url).then(function() {
        button.text('Copiato');
      }).catch(function() {
        window.prompt('Copia il link di pagamento:', url);
      });
      return;
    }

    window.prompt('Copia il link di pagamento:', url);
  });

  $(document).on('click', '.publisher', function() {
    var self = $(this);

    $.ajax({
      type: 'POST',
      url: '/ajax/setpublisher',
      data: {
        id: self.data('id')
      },
      success: function(data) {
        var response = data && data.response ? data.response : {};

        if (response.result === false && self.data('original-value') !== undefined) {
          self.val(self.data('original-value'));
        }

        if (self.hasClass('btn')) {
            if(data.response.quantity_available > 3) {
                self.toggleClass('btn-danger btn-success');
            } else {
                self.toggleClass('btn-danger btn-warning');
            }

        }
        $.each(data.response.tooltip, function(index, value) {
            $("[data-id='" + self.data('id') + "'] [data-tooltip='" + index + "']").tooltip('hide').attr('data-original-title',value).tooltip('show');
        });
      }
    });
  });

  $(document).on('click', '.pushable', function() {
    var self = $(this);

    $.ajax({
      type: 'POST',
      url: '/ajax/setfield',
      data: {
        table: self.data('table'),
        field: self.data('field'),
        id: self.data('id'),
        variant: self.data('variant'),
        value: self.data('value')
      },
      success: function(data) {
        if (self.hasClass('btn')) {
          self.toggleClass('btn-danger btn-success')
          self.attr('data-value', self.data('value') == 1 ? 0 : 1);
        }
        if (
          self.data('table') === 'orders' &&
          self.data('field') === 'paid_at' &&
          self.hasClass('btn-success')
        ) {
          var paymentMethod = self.closest('td').find('.order-payment-method');
          paymentMethod.prop('disabled', true);
          paymentMethod.closest('.bootstrap-select').hide();
          self.closest('td').find('.generate-order-payment-link, .order-payment-link-result').hide();
        }
        $.each(data.response.tooltip, function(index, value) {
            $("[data-id='" + self.data('id') + "'] [data-tooltip='" + index + "']").tooltip('hide').attr('data-original-title',value).tooltip('show');
        });
      }
    });
  });

  $('a[data-toggle="tab"]').on('shown.bs.tab', function(e) {
    //e.target // newly activated tab
    //e.relatedTarget // previous active tab
  });

  $('[data-action="event_user_user"]').on('changed.bs.select', function(
    e,
    clickedIndex,
    isSelected,
    previousValue
  ) {
    if ($(this).val()) {
      $('#event_user_user').addClass('d-none');
    } else {
      $('#event_user_user').removeClass('d-none');
    }
  });

  $('[data-toggle="select"]').on('changed.bs.select', function(
    e,
    clickedIndex,
    isSelected,
    previousValue
  ) {
    var self = $(this);
    var data = $(this).data();
    delete data.selectpicker;

    $.ajax({
      type: 'POST',
      url: '/ajax/select',
      data: {
        data: data,
        field: $(this).attr('name'),
        value: $(this).val()
      },
      success: function(data) {
        console.log(data);
        if (data.response.inject) {
          $.each(data.response.inject, function(index, value) {
            $(
              "[data-id='" +
                self.data('id') +
                "'] [data-inject='" +
                index +
                "']"
            ).html(value);
          });
          $.each(data.response.tooltip, function(index, value) {
              $("[data-id='" + self.data('id') + "'] [data-tooltip='" + index + "']").tooltip('hide').attr('data-original-title',value).tooltip('show');
          });
        }
      }
    });
  });

  $.ajaxSetup({
    headers: {
      'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
  });

  function fixWidthHelper(e, ui) {
    ui.children().each(function() {
      $(this).width($(this).width());
    });
    return ui;
  }

  $('table.table-sortable tbody').sortable({
    helper: fixWidthHelper,
    placeholder: 'ui-state-highlight',
    update: function(event, ui) {
      var data = [];
      $('table.table-sortable tbody').children('tr').each(function(index, el) {
        data.push({ id: $(this).data('id') });
      });
      $.ajax({
        type: 'POST',
        url: '/ajax/ordering',
        data: {
          data: data,
          table: 'categories',
          group: 'product'
        },
        success: function(data) {},
        error: function() {}
      });
    }
  }); //.disableSelection();

  $('.filtered').addClass('d-none');

  $("[data-toggle='toggle']").each(function() {
    if ($(this).hasClass('btn-success')) {
      $($(this).data('target')).removeClass('d-none');
    }
  });

  $(
    document
  ).on('change', "select[name='payment[payment_reference]']", function() {
    if ($(this).val() == 'event_user') {
      $('#xref_id_event_user').parents('div.row').removeClass('d-none');
      $('#xref_id_user').parents('div.row').addClass('d-none');
    } else {
      $('#xref_id_event_user').parents('div.row').addClass('d-none');
      $('#xref_id_user').parents('div.row').removeClass('d-none');
    }
  });

  $(document).on('click', "[data-toggle='toggle']", function() {
    //$(".btn-filter span").removeClass("btn-success").addClass("btn-primary");
    $(this).toggleClass('btn-primary btn-success');
    //$(this).attr("data","");
    //$('.filtered').addClass("d-none");
    $($(this).data('target')).toggleClass('d-none');

    $.ajax({
      type: 'POST',
      url: '/ajax/setstate',
      data: { data: $(this).data() },
      success: function(response) {
        console.log('✅ Risposta dal server:', response);
      },
      error: function(xhr, status, error) {
        console.error('❌ Errore AJAX:', error);
        console.log('Dettagli:', xhr.responseText);
      }
    });
  });

  $(document).on('click', "[data-toggle='addgrant']", function() {

    if($(this).closest('form').find("input[name='grant[name]']").val() == "") {
        alert("Campo nome obbligatorio");
        return false;
    }
    if($(this).closest('form').find("input[name='grant[surname]']").val() == "") {
        alert("Campo cognome obbligatorio");
        return false;
    }
    if($(this).closest('form').find("input[name='grant[email]']").val() == "") {
        alert("Campo email obbligatorio");
        return false;
    }
    if($(this).closest('form').find("input[name='grant[phone]']").val() == "") {
        alert("Campo telefono obbligatorio");
        return false;
    }
    if($(this).closest('form').find("select[name='grant[itemid]']").val() == "") {
        alert("Devi selezionare un prodotto");
        return false;
    }

    if(!confirm('Sei sicuro di voler attivare la garanzia? Questa operazione non è reversibile'))
        return false;

    if(!confirm('Sei veramente sicuro?'))
        return false;

    var form = $(this).closest('form');

    $.ajax({
        type: 'POST',
        url: '/ajax/addgrant',
        data: {
          orderid: $(this).data('orderid'),
          form: form.serialize()
        },
        success: function(data) {
            form.find("input[name='grant[transaction]']").val(data.response.transaction);
            form.find("input[name='grant[pin]']").val(data.response.pin);
            form.find(':input:not(:disabled)').prop('disabled',true);
        }
      });
  });

  $(document).on('click', "[data-toggle='showgrant']", function() {

    $.ajax({
        type: 'POST',
        url: '/ajax/showgrant',
        data: {
          orderid: $(this).data('orderid'),
          itemid: $(this).data('itemid')
        },
        success: function(data) {
            $('#modal .modal-title').html('Aggiungi garanzia');
            $('#modal .modal-body').html(data.response);
            $('#modal .modal-body .selectpicker').selectpicker();
            $('#modal').modal('show');
        }
      });

      return false;
  });

  $(document).on('click', "[data-toggle='ajax']", function() {

    var self = $(this);

    $.ajax({
      type: 'POST',
      url: '/ajax/' + $(this).data('task'),
      data: {
        data: $(this).data(),
        form: $(this).closest('form').serialize()
      },
      success: function(data) {
        if (self.data('task') == 'modal') {
          $('#modal .modal-title').html('Aggiungi prodotto');
          $('#modal .modal-body').html(data.response);
          $('#modal .modal-body .selectpicker').selectpicker();
          $('#modal').modal('show');
        } else if (self.data('task') == 'destroy') {
          $('div[data-id="' + self.data('id') + '"]').remove();
        } else if (self.data('task') == 'edititemcart') {
          console.log(data);
          $('#taxable').val(data.element.taxable);
          $('#vat').val(data.element.vat);
          $('#total').val(data.element.total);
        } else if (self.data('task') == 'addcrmmessage') {
          console.log(data.response);
        } else if (self.data('task') == 'additemcart') {
          //self.data("target");
          $('#items').prepend(data.response);
          $('#modal').modal('hide');
          $('#taxable').val(data.element.taxable);
          $('#vat').val(data.element.vat);
          $('#total').val(data.element.total);
        } else if (self.data('task') == 'remitemcart') {
          //self.data("target");
          self.parents('.item').remove();
          $('#taxable').val(data.element.taxable);
          $('#vat').val(data.element.vat);
          $('#total').val(data.element.total);
        } else {
          self.replaceWith(data.html);
          $("form[data-id='" + self.data('id') + "'").toggleClass('d-none');
        }
      }
    });
  });

  $(document).on('click', "[data-action='remove']", function() {
    $(document).find('#' + $(this).data('target')).remove();
  });

  $(document).on('click', "[data-action='append']", function() {
    $(this)
      .val('Elimina')
      .attr('data-action', 'remove')
      .toggleClass('btn-success btn-danger ');
    retrieve('administrator.events.partials.fare', '#prices', $(this).data());
  });

  $(document).on('click', "[data-action='new_event_user']", function() {
    var form = $('form[name="new_event_user"');
    var event_id = $("select[name='event']").val();
    if (!event_id) {
      alert('Select an event to proceed');
      return false;
    }
    form.attr('action', form.attr('action') + '?event=' + event_id);
    form.submit();
  });

  $(document).on('submit', 'form[name="download"]', function() {
    if (!$('#sponsor').val() && !$('#sponsor2').val()) {
      alert('Fill one of sponsor fields');
      return false;
    }

    if (!$("input[name='enrolling']").val()) {
      alert('Fill number of delegated field');
      return false;
    }
  });

  $(document).on('change', 'select#sponsor', function() {
    $("input[name='sponsor']").val($(this).val());
  });

  $(document).on('keyup', 'input#sponsor2', function() {
    $("input[name='sponsor']").val($(this).val());
  });

  $(document).on('change', 'input[type="file"]', function() {
    //get the file name
    var fileName = $(this).val();
    //replace the "Choose a file" label
    $(this).parent().find('.custom-file-label').html(fileName);
    retrieve('administrator.medias.partials.file', '.medias');
  });

  // pagina gestione iscritti ERCONGRESSI
  $(document).on('change', 'select[data-action="disable"]', function() {
    var disabled = $(this).val() == 1;
    $('#' + $(this).data('target')).find('input, select').each(function() {
      $(this).prop('disabled', disabled);
      $('.selectpicker').selectpicker('refresh');
    });
  });

  function retrieve(tmpl, after, data = null) {
    $.ajax({
      type: 'POST',
      url: '/ajax/retrieve',
      data: {
        tmpl: tmpl,
        data: data
      },
      success: function(data) {
        $(after).append(data.response);
      }
    });
  }

  $(document).on('click', "[data-toggle='log']", function() {
    eventlog($(this).data('message'), $(this).data('event-id'));
  });

  function eventlog(message, event_id) {
    $.ajax({
      type: 'POST',
      url: '/ajax/log',
      data: {
        message: message,
        event_id: event_id
      },
      success: function(data) {}
    });
  }

  $(document).on('click', "[data-toggle='ajaxmodal']", function() {
    modalcontent(
      $(this).data('target'),
      $(this).data('tmpl'),
      $(this).data('event-id'),
      $(this).data('title'),
      $(this).data('side')
    );
  });

  function modalcontent(modal, tmpl, event_id, title, side) {
    $.ajax({
      type: 'POST',
      url: '/ajax/' + side + 'modalcontent',
      data: {
        tmpl: tmpl,
        event_id: event_id
      },
      success: function(data) {
        $(modal + ' .modal-header .modal-title').html(title);
        $(modal + ' .modal-body').html(data.body);
        $(modal).modal('show');
      }
    });
  }

  $(document).on('click', 'button.alert-confirm', function(e) {
    e.preventDefault();
    var entity = $(this).data('entity');
    var that = $(this);
    return bootbox.dialog({
      title: 'Rimuovere ' + entity + '?',
      message: 'Sei sicuro di voler rimuovere questo/a ' + entity + '?',
      buttons: {
        cancel: {
          label: 'No',
          className: 'btn-primary',
          callback: function(e) {
            return true;
          }
        },
        confirm: {
          label: 'Sì',
          className: 'btn-danger',
          callback: function(e) {
            that.closest('form').trigger('submit');
            return true;
          }
        }
      }
    });
  });

  // Calcolo prezzi dei prodotti con IVA
  function validateNumber(value) {
    if (value == null || value.trim() == '') {
      value = 0;
    }

    value = parseFloat(value);

    return value;
  }

  function roundNumber(value) {
    return Math.round(value * 100) / 100;
  }

  let vatPrice = validateNumber(
    $("input[id='vat'][name='product[vat]']").val()
  );

  $('input[id^="vat_price_"]').each(function(index, element) {
    let price = validateNumber($(this).val());
    let priceWithVat = price / 100 * (100 + vatPrice);
    priceWithVat = roundNumber(priceWithVat);
    $(this).val(priceWithVat);
  });

  $(
    document
  ).on(
    'keyup',
    'input[id="vat"][name="product[vat]"], input[id^="vat_price_"]',
    function(e) {
      if ($(this).attr('id') === 'vat') {
        vatPrice = validateNumber($(this).val());
      }

      $('input[id^="vat_price_"]').each(function(index, element) {
        let priceWithVat = validateNumber($(this).val());
        let priceNoVat = priceWithVat / (1 + vatPrice / 100);
        priceNoVat = roundNumber(priceNoVat);
        // Non funziona
        // $(this).closest('input[name^="prices["]').val(priceNoVat);
        // console.log($(this).closest('input[name^="prices["]'));
        let id = $(this).attr('id').replace('vat_price_', '');
        $('input[name="prices[' + id + ']"]').val(priceNoVat);
      });
    }
  );


    $('#province_id').select2().on('change', function() {
        $.ajax({
            url:"/ajax/cities/" + $('#province_id').val(), // if you say $(this) here it will refer to the ajax call not $('.company2')
            type:'GET',
            success:function(data) {
                $("#city_id").empty();
                $.each(data, function(value, key) {
                    $("#city_id").append($("<option></option>").attr("value", value).text(key)); // name refers to the objects value when you do you ->lists('name', 'id') in laravel
                });
                $("#city_id").select2(); //reload the list and select the first option
            }
        });
    });

    $('#shipping_province_id').select2().on('change', function() {
        $.ajax({
            url:"/ajax/cities/" + $('#shipping_province_id').val(), // if you say $(this) here it will refer to the ajax call not $('.company2')
            type:'GET',
            success:function(data) {
                $("#shipping_city_id").empty();
                $.each(data, function(value, key) {
                    $("#shipping_city_id").append($("<option></option>").attr("value", value).text(key)); // name refers to the objects value when you do you ->lists('name', 'id') in laravel
                });
                $("#shipping_city_id").select2(); //reload the list and select the first option
            }
        });
    });

    // SCHERMATA INDEX

    $('.selectVendors').select2({
        placeholder: 'Seleziona un marchio',
        ajax: {
        url: '/ajax/select/vendors',
        dataType: 'json',
        delay: 250,
        processResults: function (data) {
            return {
                results:  $.map(data, function (item) {
                    return {
                        text: item.name,
                        id: item.id
                    }
                })
            };
        },
        cache: true
        }
    });

    $('.selectProducts').select2({
        placeholder: 'Seleziona un prodotto',
        ajax: {
        url: '/ajax/select/products',
        dataType: 'json',
        delay: 250,
        processResults: function (data) {
            return {
                results:  $.map(data, function (item) {
                    return {
                        text: item.id + ': ' + item.name + ' (' + item.ean + ')',
                        id: item.id
                    }
                })
            };
        },
        cache: true
        }
    });

    $('.selectUsers').select2({
        placeholder: 'Seleziona un utente',
        ajax: {
        url: '/ajax/select/users',
        dataType: 'json',
        delay: 250,
        processResults: function (data) {
            return {
                results:  $.map(data, function (item) {
                    return {
                        text: item.name,
                        id: item.id
                    }
                })
            };
        },
        cache: true
        }
    });

  $('input[id^="retail-price-"]').each(function(index, element) {
    let price = validateNumber($(this).val());
    let id = $(this).attr('id').replace('retail-price-', '');
    let vatPrice = validateNumber($('input[id^="vat-' + id + '"]').val());
    let priceWithVat = price / 100 * (100 + vatPrice);
    priceWithVat = roundNumber(priceWithVat);
    $(this).val(priceWithVat);
  });

  $(document).on('keyup', 'input[id^="retail-price-"]', function(e) {
    let $this = $(this);
    let id = $this.attr('id').replace('retail-price-', '');
    let vatPrice = validateNumber($('input[id^="vat-' + id + '"]').val());
    let priceWithVat = validateNumber($this.val());
    let priceNoVat = priceWithVat / (1 + vatPrice / 100);
    priceNoVat = roundNumber(priceNoVat);
    $('input[id^="retail-novat-price-' + id + '"]').val(priceNoVat);
    setTimeout(function() {
      if (
        priceWithVat ==
        validateNumber($('input[id="retail-price-' + id + '"]').val() && Number(priceWithVat))
      ) {
        $.ajax({
          type: 'POST',
          url: '/ajax/update-product-retailprice',
          data: {
            id: id,
            price: priceNoVat
          },
          error: function(data) {
            console.error(data);
          }
          // success: function(data) {
          //   console.log(data);
          // }
        });
      }
    }, 1200);
  });

  // END Calcolo prezzi dei prodotti con IVA

  window.addEventListener('contentChanged', event => {
    $('select').selectpicker();
  });
});
